module.exports = __webpack_public_path__ + "static/state-6164a2c66901b2a3227c1329f130d7c3.png";